const SITE_NAME = process.env.REACT_APP_SITE_NAME;
const SITE_URL = process.env.REACT_APP_SITE_URL;

export default function websiteSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",

    "@id": `${SITE_URL}/#website`,

    url: SITE_URL,

    name: SITE_NAME,

    description:
      "Compare and apply for Home Loans, Mortgage Loans, Business Loans, Construction Loans, Loan Against Property (LAP), Personal Loans and more from leading Banks and NBFCs.",

    publisher: {
      "@id": `${SITE_URL}/#organization`,
    },

    inLanguage: "en-IN",
  };
}